<!--
 * @Author: your name
 * @Date: 2021-04-27 14:23:35
 * @LastEditTime: 2021-05-26 11:38:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/components/common/recordFramework.vue
-->
<template>
  <div>
    <el-dialog
      title="关联投放记录"
      :visible.sync="customListModal"
      width="1000px"
      class="yhg-dialog"
      @open="openCustomSelectModal"
      @close="recordClose"
    >
      <div class="select-con single">
        <span class="label">已关联投放记录：</span>
        <div class="content" v-if="selectCustom">
          <el-tag
            v-if="selectCustom.code"
            class="select-tag"
            closable
            :type="selectCustom.code"
            effect="dark"
            @close="onCustomTagClose"
          >
            <span class="select-tag-text">{{ selectCustom.code }}</span>
          </el-tag>
        </div>
      </div>
      <div class="filter-con">
        <el-input clearable size="small" v-model="customForm.code" placeholder="投放记录编号/名称" @keyup.enter.native="onCustomSearch"></el-input>
        <el-input clearable style="margin:0 20px;" size="small" v-model="customForm.bloggerName" placeholder="博主姓名" @keyup.enter.native="onCustomSearch"></el-input>
        <el-input clearable size="small" v-model="customForm.customerName" placeholder="客户姓名" @keyup.enter.native="onCustomSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onCustomSearch">查 询</el-button>
      </div>
      <div class="table-con">
        <el-table
          :data="customTable"
          v-loading="customTableLoading"
          size="mini"
          ref="customSelectTable"
        >
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <span class="hide-label-radio">
                <el-radio
                  :disabled="scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3?false:true"
                  v-model="selectCustomId"
                  @change="onChangeCustom"
                  :label="scope.row.code"
                ></el-radio>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="投放编号" min-width="120" prop="code" align="center"></el-table-column>
          <el-table-column label="博主名称" prop="bloggerName" min-width="160" align="center">
          </el-table-column>
          <el-table-column label="平台" prop="mediaType" align="center">
            <template slot-scope="scope">
              {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, '') }}
            </template>
          </el-table-column>
          <el-table-column label="关联合同" prop="contract" align="center" min-width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.contractName">
                <p>{{ scope.row.contractName }}</p>
                <p>{{ scope.row.contractCode }}</p>
                <p class="non-wrap">（<span :class="['color_' + contractConfig.getAppointed('status_color', scope.row.contractStatus)]">{{ contractConfig.getAppointed("status_summary", scope.row.contractStatus, '') }}</span>）</p>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="执行价" prop="executePrice" align="center"></el-table-column>
          <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
          <el-table-column label="品牌名称" prop="brandName" align="center"></el-table-column>
          <el-table-column label="发布形式" prop="publishType" align="center"></el-table-column>
          <el-table-column label="发布日期" min-width="120" prop="publishTime" align="center">
            <template slot-scope="scope">
              {{ scope.row.publishTime && scope.row.publishTime.split(' ')[0] }}
            </template>
          </el-table-column>
          
        </el-table>
      </div>
      <div class="pagination-wrap">
          <el-pagination
            background
            @size-change="customSizeChange"
            @current-change="customCurrentChange"
            :current-page.sync="customForm.pageNum"
            :page-sizes="[5, 10, 20, 25, 50]"
            :page-size="customForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmCustomChoose">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listDeliveryPlatform } from "@/api/business/delivery";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/contract";
export default {
  props: {
    recordDialog: {
      type: Boolean,
      default: false
    },
    recordValue:{
      type: Object,
    },
  },
  data() {
    return {
      recordShow:true,
      customListModal:this._props.recordDialog,
      total: 0,
      customForm: {
        customerName:"",
        bloggerName:"",
        code:"",
        pageSize: 5,
        pageNum: 1,
      },
      mediaConfig: mediaConfig,
      contractConfig: contractConfig,
      selectCustomId: null,
      selectCustom: null,
      customTable: [],
      customTableLoading: false,
      statusList:['','启动审批中','启动审批不通过','进行中','进行中(结案审批中)','进行中(结案审批不通过)','已结案','进行中(关闭审批中)','进行中(关闭审批不通过)','已关闭'],
    };
  },
  watch:{
    recordDialog: {
      handler(newVal, oldVal) {
        this.customListModal = newVal;
        if(newVal){
          this.selectCustomId = this.recordValue.code
          this.selectCustom = this.recordValue
          // this.openCustomSelectModal()
        }
      },
      deep: true
    },
  },
  methods: {
    recordClose(){
      this.customForm.businessPrincipal = "";
      this.customForm.customerName="";
      this.customForm.nameOrCode="";
      this.$emit('recordClose')
    },
    //确认
    onConfirmCustomChoose(){
      this.$emit('customChooseSave',this.selectCustomId)
    },
    //资源选择变化
    onChangeCustom(val) {
      this.selectCustom.code = val ;
    },
    //资源标签删除
    onCustomTagClose() {
      this.selectCustom = null;
      this.selectCustomId = null;
    },
    //资源选择弹窗打开
    openCustomSelectModal() {
      this.onCustomSearch();
    },
    //资源搜索
    onCustomSearch() {
      this.customForm.pageNum = 1;
      this.getCustomList();
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    customSizeChange(val) {
      this.customForm.pageNum = 1;
      this.customForm.pageSize = val;
      this.getCustomList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    customCurrentChange(val) {
      this.customForm.pageNum = val;
      this.getCustomList();
    },
    //获取资源列表
    getCustomList() {
      listDeliveryPlatform(this.customForm).then((res) => {
        if(res.code === 1){
          this.customTable = res.data
          this.total = res.total
        }
        console.log('========查询数========',res)
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.table-con{
    height: 270px;
    overflow: auto;
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
